import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { OrderDetailsService } from '../../../services/order-details/order-details.service';

@Component({
    selector: 'other-features',
    templateUrl: './other-features.component.html',
    styleUrls: ['./other-features.component.scss'],
    standalone: false
})
export class OtherFeaturesComponent implements OnInit {

  otherFeaturesForm: UntypedFormGroup;
  @Input() orderData: any;
  @Input() orderID;
  @Output() errorMsg = new EventEmitter;
  @Output() enableSave = new EventEmitter;
  features: any = [] ;

  constructor (
    private formBuilder : UntypedFormBuilder,
    private orderDetails : OrderDetailsService){
  }

  ngOnInit(): void {
    this.features = this.orderData.building_other_features;
    this.createForm();
    this.createFormControls();
    this.patchValues();
  }

  createForm(){
    this.otherFeaturesForm = this.formBuilder.group({
      building_other_features : []
    })
  }

  createFormControls() {
    return this.otherFeaturesForm.controls;
  }

  featureValueChanged(event , index){
    this.features[index].value = event.target.checked  ;
    this.patchValues();
  }

  patchValues(){
    this.otherFeaturesForm.get('building_other_features').setValue(this.features);
  }

  save(event){
    let data ={
      building_other_features : this.otherFeaturesForm.get('building_other_features').value
    }
    this.orderDetails.updateOtherFeatures(this.orderID , data, event.buttonId).subscribe(
      res=> {
        this.showConfirmationModal();
      }
    )
  }

  showConfirmationModal(){
    this.errorMsg.emit({
      message :"تم تحديث البيانات بنجاح.",
      imgSuccess : true
    });
  }
  
}
